import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="py-16 px-5 sm:px-10"
      style={{ backgroundColor: "#1F2937" }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-10">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">
              A3 Technologies Inc.
            </h3>
            <a
              href="tel:7783497449"
              className="text-lg text-white mb-2 block hover:text-gray-300"
              data-testid="footer-phone"
            >
              (778) 349-7449
            </a>
            <p style={{ color: "#9CA3AF" }}>
              Professional IT Services for Growing Businesses
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Quick Links</h3>
            <nav className="flex flex-col gap-3">
              <Link
                to="/"
                className="text-left hover:text-white transition-colors"
                style={{ color: "#D1D5DB" }}
                data-testid="footer-link-home"
              >
                Home
              </Link>
              <Link
                to="/services"
                className="text-left hover:text-white transition-colors"
                style={{ color: "#D1D5DB" }}
                data-testid="footer-link-services"
              >
                Services
              </Link>
              <Link
                to="/about"
                className="text-left hover:text-white transition-colors"
                style={{ color: "#D1D5DB" }}
                data-testid="footer-link-about"
              >
                About
              </Link>
              <Link
                to="/contact"
                className="text-left hover:text-white transition-colors"
                style={{ color: "#D1D5DB" }}
                data-testid="footer-link-contact"
              >
                Contact
              </Link>
              <Link
                to="/privacy"
                className="text-left hover:text-white transition-colors"
                style={{ color: "#D1D5DB" }}
                data-testid="footer-link-privacy"
              >
                Privacy Policy
              </Link>
            </nav>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Services</h3>
            <nav className="flex flex-col gap-3">
              <Link
                to="/services"
                className="text-left hover:text-white transition-colors"
                style={{ color: "#D1D5DB" }}
              >
                Managed IT
              </Link>
              <Link
                to="/services/cybersecurity"
                className="text-left hover:text-white transition-colors"
                style={{ color: "#D1D5DB" }}
              >
                Cybersecurity
              </Link>
              <Link
                to="/services"
                className="text-left hover:text-white transition-colors"
                style={{ color: "#D1D5DB" }}
              >
                Cloud Solutions
              </Link>
              <Link
                to="/services"
                className="text-left hover:text-white transition-colors"
                style={{ color: "#D1D5DB" }}
              >
                IT Consulting
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="pt-8 mt-10 text-center"
          style={{ borderTop: "1px solid #374151" }}
        >
          <p className="text-sm" style={{ color: "#9CA3AF" }}>
            © 2025 A3 Technologies Inc. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
